import { IBaseEditorProps, BaseEditor } from "./BaseEditor";

import { IRadiosSpecificProps } from "./Radios";

import * as React from "react";

import { RadiosFactory } from "./Factories/RadiosFactory";
import { isNotEmpty } from "./Validation/RawValueRules";
import { Guid } from "../Utils/Guid";
import * as classNames from "classNames";

export interface IRadiosEditorProps<TOption>
    extends IBaseEditorProps,
    IRadiosSpecificProps<TOption>,
    React.Props<RadiosEditor<TOption>> { }

export class RadiosEditor<TOption> extends BaseEditor<IRadiosEditorProps<TOption>> {
    constructor(props: IRadiosEditorProps<TOption>) {
        super(props);
    }

    public render(): JSX.Element {
        const wrapperCss = classNames("radio-group", this.props.cssWrapper, {
            error: this.state.typingFinished && !this.state.isValid && !this.state.isValidOutside,
            valid: this.state.typingFinished && this.state.isValid && this.state.isValidOutside,
        });
        

        return (
            <fieldset
                className={wrapperCss}
                aria-labelledby={this.state.inputGroupId + "_legend"}
                ref={(elem: HTMLElement) => (this.wrapperRef = elem)}
            >
                {this.props.labelGridClasses && (
                    <div>
                        <div className={this.props.labelGridClasses}>{this.getLegend()}</div>
                    </div>
                )}
                {!this.props.labelGridClasses && this.getLegend()}

                {this.props.inputGridClasses && (
                    <div className="row">
                        <div className={this.props.inputGridClasses}>
                            {this.getInput()}
                            {this.getValidationErrorsContainer()}
                        </div>
                    </div>
                )}
                {!this.props.inputGridClasses && (
                    <div>
                        {this.getInput()}
                        {this.getValidationErrorsContainer()}
                    </div>
                )}

                {this.getInfoText()}
            </fieldset>
        );
    }

    public componentDidMount(): void {
        this.bindLabelToInput();
    }

    protected getLegend(): JSX.Element {
        return (
            <div className="row no-gutter">
                <div className="col-auto">{this.getDescription()}</div>
                <div className="col-auto">{this.getTooltip()}</div>
            </div>
        );
    }

    protected getInput(): JSX.Element {
        const Radios = RadiosFactory.create<TOption>();
        return (
            <Radios
                {...(this.props as any)}
                id={this.state.inputGroupId}
                onValidationResultChange={(isValid: boolean, errors: string[], showValidationMessages: boolean) =>
                    this.handleValidationResultChange(isValid, errors, showValidationMessages)
                }
                disabled = {this.props.disabled}
                onBlur={(value) => this.onBlur(value)}
                ariaDescribedby={this._errorMessageId + " " + this._infoTextId}
                ariaInvalidCanBeShown={this.state.typingFinished}
                ariaInvalidShouldBeShown={!this.state.isValidOutside}
            />
        );
    }

    private onBlur(value: TOption): void {
        if (this.props.onBlur) {
            this.props.onBlur(value);
        }

        this.setState({ typingFinished: true });
    }

    private getDescription(): JSX.Element {
        if (!this.props.label) {
            return null;
        }

        return <legend id={this.state.inputGroupId + "_legend"}>{this.props.label}</legend>;
    }

    private bindLabelToInput(): void {
        let propId: string = null;
        if (this.props.hasOwnProperty("id")) {
            propId = this.props.id;
        }

        const id = isNotEmpty(propId) ? propId : Guid.getNext();
        this.setState({ inputGroupId: id });
    }

    private handleValidationResultChange(isValid: boolean, errors: string[], showValidationMessages: boolean): void {
        this.onValidationResultChange(isValid, errors, showValidationMessages);

        if (this.props.onValidation) {
            this.props.onValidation(errors);
        }
    }
}
